import { Search, Filter, SlidersHorizontal } from 'lucide-react';

interface LeadFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
  assignmentFilter: string;
  onAssignmentFilterChange: (filter: string) => void;
}

export function LeadFilters({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  assignmentFilter,
  onAssignmentFilterChange,
}: LeadFiltersProps) {
  return (
    <div className="project-filters bg-white border border-gray-200 rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row gap-4">
        {/* Search */}
        <div className="flex-1">
          <div className="project-filter project-filter--search app-search-field">
            <Search className="app-field-icon" />
            <input
              type="text"
              placeholder="Search projects by title, description, or location..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {/* Status Filter */}
        <div className="flex gap-3">
          <div className="project-filter app-icon-field">
            <Filter className="app-field-icon" />
            <select
              value={statusFilter}
              onChange={(e) => onStatusFilterChange(e.target.value)}
              className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none bg-white min-w-[150px]"
            >
              <option value="all">All Status</option>
              <option value="OPEN">Open</option>
              <option value="REQUESTED">Requested</option>
              <option value="ACCEPTED">Accepted</option>
              <option value="COMPLETED">Completed</option>
            </select>
          </div>

          {/* Assignment Filter */}
          <div className="project-filter app-icon-field">
            <SlidersHorizontal className="app-field-icon" />
            <select
              value={assignmentFilter}
              onChange={(e) => onAssignmentFilterChange(e.target.value)}
              className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none bg-white min-w-[150px]"
            >
              <option value="all">All Leads</option>
              <option value="assigned">Assigned</option>
              <option value="unassigned">Unassigned</option>
              <option value="requested">Requested</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
